module.exports = __webpack_public_path__ + "static/media/icon-reddit-primary.6cd97143.svg";